import React from 'react';
import User from './User'

class CreateUser extends User {

  getReturnButton() {
    return null
  }
}

export default CreateUser;



// WEBPACK FOOTER //
// ./src/components/CreateUser.js